/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ICreateSetupParameterFilter } from './ICreateSetupParameterFilter';
import {
    ICreateSetupParameterFilterFromJSON,
    ICreateSetupParameterFilterFromJSONTyped,
    ICreateSetupParameterFilterToJSON,
} from './ICreateSetupParameterFilter';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';
import type { CreateEvaluationParameterDto } from './CreateEvaluationParameterDto';
import {
    CreateEvaluationParameterDtoFromJSON,
    CreateEvaluationParameterDtoFromJSONTyped,
    CreateEvaluationParameterDtoToJSON,
} from './CreateEvaluationParameterDto';

/**
 * 
 * @export
 * @interface DataSetRequestDto
 */
export interface DataSetRequestDto {
    /**
     * 
     * @type {string}
     * @memberof DataSetRequestDto
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataSetRequestDto
     */
    endDate?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataSetRequestDto
     */
    targetSystemIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataSetRequestDto
     */
    supportSystemIds?: Array<string> | null;
    /**
     * 
     * @type {Array<TaskTypeDescription>}
     * @memberof DataSetRequestDto
     */
    selectedTaskTypes?: Array<TaskTypeDescription> | null;
    /**
     * 
     * @type {Array<ICreateSetupParameterFilter>}
     * @memberof DataSetRequestDto
     */
    targetSystemSetupFilters?: Array<ICreateSetupParameterFilter> | null;
    /**
     * 
     * @type {Array<ICreateSetupParameterFilter>}
     * @memberof DataSetRequestDto
     */
    supportSystemSetupFilters?: Array<ICreateSetupParameterFilter> | null;
    /**
     * 
     * @type {Array<CreateEvaluationParameterDto>}
     * @memberof DataSetRequestDto
     */
    evaluationParameterFilters?: Array<CreateEvaluationParameterDto> | null;
    /**
     * 
     * @type {number}
     * @memberof DataSetRequestDto
     */
    maximumDataSetCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataSetRequestDto
     */
    $type?: DataSetRequestDtoTypeEnum;
}


/**
 * @export
 */
export const DataSetRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoDataSetRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.DataSetRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DataSetRequestDtoTypeEnum = typeof DataSetRequestDtoTypeEnum[keyof typeof DataSetRequestDtoTypeEnum];



/**
 * Check if a given object implements the DataSetRequestDto interface.
 */
export function instanceOfDataSetRequestDto(value?: unknown): value is DataSetRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DataSetRequestDtoTypeEnum)[0];
}

export function DataSetRequestDtoFromJSON(json: any): DataSetRequestDto {
    return DataSetRequestDtoFromJSONTyped(json, false);
}

export function DataSetRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSetRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'targetSystemIds': json['targetSystemIds'] == null ? undefined : json['targetSystemIds'],
        'supportSystemIds': json['supportSystemIds'] == null ? undefined : json['supportSystemIds'],
        'selectedTaskTypes': json['selectedTaskTypes'] == null ? undefined : ((json['selectedTaskTypes'] as Array<any>).map(TaskTypeDescriptionFromJSON)),
        'targetSystemSetupFilters': json['targetSystemSetupFilters'] == null ? undefined : ((json['targetSystemSetupFilters'] as Array<any>).map(ICreateSetupParameterFilterFromJSON)),
        'supportSystemSetupFilters': json['supportSystemSetupFilters'] == null ? undefined : ((json['supportSystemSetupFilters'] as Array<any>).map(ICreateSetupParameterFilterFromJSON)),
        'evaluationParameterFilters': json['evaluationParameterFilters'] == null ? undefined : ((json['evaluationParameterFilters'] as Array<any>).map(CreateEvaluationParameterDtoFromJSON)),
        'maximumDataSetCount': json['maximumDataSetCount'] == null ? undefined : json['maximumDataSetCount'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DataSetRequestDtoToJSON(value?: DataSetRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'targetSystemIds': value['targetSystemIds'],
        'supportSystemIds': value['supportSystemIds'],
        'selectedTaskTypes': value['selectedTaskTypes'] == null ? undefined : ((value['selectedTaskTypes'] as Array<any>).map(TaskTypeDescriptionToJSON)),
        'targetSystemSetupFilters': value['targetSystemSetupFilters'] == null ? undefined : ((value['targetSystemSetupFilters'] as Array<any>).map(ICreateSetupParameterFilterToJSON)),
        'supportSystemSetupFilters': value['supportSystemSetupFilters'] == null ? undefined : ((value['supportSystemSetupFilters'] as Array<any>).map(ICreateSetupParameterFilterToJSON)),
        'evaluationParameterFilters': value['evaluationParameterFilters'] == null ? undefined : ((value['evaluationParameterFilters'] as Array<any>).map(CreateEvaluationParameterDtoToJSON)),
        'maximumDataSetCount': value['maximumDataSetCount'],
        '$type': value['$type'],
    });
}

